import { getPlatformLogoPath, getPlatformDisplayName } from 'src/app/common/platformUtils';
import { Platform } from '../api';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const PlatformSelectOptions: ISelectOption[] = [
  {
    id: Platform.powerplatform,
    value: Platform.powerplatform,
    displayName: getPlatformDisplayName(Platform.powerplatform),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.powerplatform),
  },
  {
    id: Platform.chatGptEnterprise,
    value: Platform.chatGptEnterprise,
    displayName: getPlatformDisplayName(Platform.chatGptEnterprise),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.chatGptEnterprise),
  },
  {
    id: Platform.amazonBedrock,
    value: Platform.amazonBedrock,
    displayName: getPlatformDisplayName(Platform.amazonBedrock),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.amazonBedrock),
  },
  {
    id: Platform.salesforce,
    value: Platform.salesforce,
    displayName: getPlatformDisplayName(Platform.salesforce),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.salesforce),
  },
  {
    id: Platform.serviceNow,
    value: Platform.serviceNow,
    displayName: getPlatformDisplayName(Platform.serviceNow),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.serviceNow),
  },
  {
    id: Platform.workato,
    value: Platform.workato,
    displayName: getPlatformDisplayName(Platform.workato),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.workato),
  },
  {
    id: Platform.powerBI,
    value: Platform.powerBI,
    displayName: getPlatformDisplayName(Platform.powerBI),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.powerBI),
  },
  {
    id: Platform.google,
    value: Platform.google,
    displayName: getPlatformDisplayName(Platform.google),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.google),
  },
  {
    id: Platform.devices,
    value: Platform.devices,
    displayName: getPlatformDisplayName(Platform.devices),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.devices),
  },
  {
    id: Platform.budibase,
    value: Platform.budibase,
    displayName: getPlatformDisplayName(Platform.budibase),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.budibase),
  },
  {
    id: Platform.airtable,
    value: Platform.airtable,
    displayName: getPlatformDisplayName(Platform.airtable),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.airtable),
  },
  {
    id: Platform.outpost_powerplatform,
    value: Platform.outpost_powerplatform,
    displayName: getPlatformDisplayName(Platform.outpost_powerplatform),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.outpost_powerplatform),
  },
  {
    id: Platform.cursor,
    value: Platform.cursor,
    displayName: getPlatformDisplayName(Platform.cursor),
    filterType: FilterTypesEnum.Platform,
    categoryName: FilterTypesEnum.Platform.toString(),
    iconPath: getPlatformLogoPath(Platform.cursor),
  },
];
